(function () {
    var SELECTORS = [
        '.bl1',
        '.title-mobile h1',
        '.gbbPbProductCardTitleLink',
        'a[itemprop="item"] span[itemprop="name"]',
        '.testimonials-area p',
        '.text-containet-additional p, .text-containet-additional span',
        '.card-information__text, .card-information__wrapper > small',
        '.OutlineElement p',
        '.full-unstyled-link',
        '.product__info-wrapper',
        '.full-unstyled-link',
        '.product__description',
        '.banner__heading',
        '.bottom-lines',
        '[class*="moisyn-hero"]',
        '[class*="moisyn-testi"]',
        '.title-products',

        /* Moisyn Home Hero */
        '.home-hero-container h2',
        '.home-hero-container h3',
        '.home-hero-container a',
        '.faq-answer',
        /* Custom header menu */
        '.custom-header-menuc2 a',
        /* Product description */
        '.readmore-text',
        /* Moisyn configuration list */
        '.moisyn-configs__list',
        /* Allergen notice */
        '.moisyn-approach__allergen'
    ].join(',');

    function wrapReg(root) {
        var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
        var nodes = [];
        while (walker.nextNode()) {
        var n = walker.currentNode;
        if (n.nodeValue.indexOf('®') > -1 && n.parentNode.nodeName !== 'SUP') nodes.push(n);
        }
        nodes.forEach(function (node) {
        var frag = document.createDocumentFragment();
        node.nodeValue.split('®').forEach(function (part, i, arr) {
            frag.appendChild(document.createTextNode(part));
            if (i < arr.length - 1) {
            var sup = document.createElement('sup');
            sup.className = 'reg-mark';
            sup.textContent = '®';
            frag.appendChild(sup);
            }
        });
        node.parentNode.replaceChild(frag, node);
        });
    }

    function run() {
        document.querySelectorAll(SELECTORS).forEach(wrapReg);
    }

    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();